const state = {
  page: 0,
};
const getters = {
  pageGet: (state) => state.page,
};
const actions = {
  set_page({ commit }, payload) {
    commit("SET_PAGE", payload);
  },
};
const mutations = {
  SET_PAGE(state, payload) {
    state.page = payload;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
